import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

// Context
import { useFormSelectDialog, optionShape, getDialogOptionId } from "./index";

// styles
import {
    DialogOptionStyled,
    CheckMarkWrapperStyled,
    DialogOptionTextStyled
} from "./styles";

// components
import Checkmark from "core/ReusableIcons/Checkmark";

const DialogOption = ({ option }) => {
    // state/props
    const {
        id,
        hasOpenedBefore,
        isOpen,
        setIsOpen,
        selectedOption,
        setSelectedOption
    } = useFormSelectDialog();

    const dialogOptionRef = useRef();
    const isSelected = selectedOption.id === option.id;

    // methods
    const selectOption = () => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    // side effects
    useEffect(() => {
        if (hasOpenedBefore && isOpen && isSelected) {
            dialogOptionRef.current.focus();
        }
    }, [hasOpenedBefore, isOpen]);

    return (
        <DialogOptionStyled
            type="button"
            onClick={selectOption}
            id={getDialogOptionId(id, option.id)}
            ref={dialogOptionRef}
            isSelected={isSelected}
            data-testid="dialog-option"
        >
            <CheckMarkWrapperStyled>
                {isSelected && <Checkmark size={{ width: 16, height: 16 }} />}
            </CheckMarkWrapperStyled>
            <DialogOptionTextStyled>{option.text}</DialogOptionTextStyled>
        </DialogOptionStyled>
    );
};

export default DialogOption;

// prop-types
DialogOption.propTypes = {
    option: PropTypes.shape(optionShape).isRequired
};
